<div class="container-fluid filter-box">
    <div class="col-12 d-flex mb-2 filter-content">
        <input
            type="text"
            class="form-control filter-input text-start"
            (keyup)="filterResults()"
            [(ngModel)]="searchTerm"
            placeholder="{{ 'companies.search' | translate }}"
        />
        <button
            *ngIf="userRole"
            class="btn btn-primary ms-2"
            (click)="newCompany()"
        >
            {{ 'companies.btn_new_company' | translate }}
        </button>
    </div>
</div>
<div class="mat-elevation-z2 company-tables">
    <table mat-table [dataSource]="dataSource" matSort class="fixed-table">
        <!-- ID Column -->
        <ng-container matColumnDef="mowaId">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                {{ 'companies.id' | translate }}
            </th>
            <td mat-cell
                  *matCellDef="let element"
                  class="td-id"
                  [ngClass]="{
                    'sync': checkSyncStatus(element)}"
                  >
                {{ checkSyncStatus(element) ?  ('response.sync_company' | translate) : element.mowaId }}
            </td>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                {{ 'companies.name' | translate }}
            </th>
            <td mat-cell *matCellDef="let element" class="td-company">
                {{element.name}}
            </td>
        </ng-container>

        <!-- Email Column -->
        <ng-container matColumnDef="email">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                {{ 'companies.email' | translate }}
            </th>
            <td mat-cell *matCellDef="let element" class="td-company">
                {{element.email}}
            </td>
        </ng-container>

        <!-- City Column -->
        <ng-container matColumnDef="city">
            <th
                mat-header-cell
                *matHeaderCellDef
                mat-sort-header
                class="td-city"
            >
                {{ 'companies.city' | translate }}
            </th>
            <td mat-cell *matCellDef="let element" class="td-city">
                {{element.city}}
            </td>
        </ng-container>

        <ng-container matColumnDef="details">
            <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
            <td mat-cell *matCellDef="let element" class="details">
                <div class="d-flex justify-content-end align-items-center">
                    <div class="d-flex justify-content-start align-items-center">
                        <div *ngIf="checkSyncStatus(element)" class="loader"></div>
                    </div>
                    <button
                    [ngClass]="{
                        'btn-second': checkSyncStatus(element),
                        'btn-primary': !checkSyncStatus(element)
                    }"
                        class="btn btn-xs-small"
                        (click)="viewCompany(element.id)"
                    >
                        details
                    </button>
                </div>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

    <mat-paginator
        [pageSizeOptions]="[10, 20]"
        showFirstLastButtons
    ></mat-paginator>
</div>
